import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Tag, Checkbox, Button, Card } from 'antd';
import { remove } from 'lodash'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable/index.jsx';
import {usePagination} from '../../../../hooks/useFiltersPagination.js';


const { Search } = Input;

const UserProfile = (
  {
    tipoSuscripcion,
    setTipoSuscripcion,
    mercado,   
    setMercado,
    lineAge,
    setLineAge,
    userPlan,
    setUserPlan
  }
) => {
  
  const [selectedData1, setSelectedData1] = useState();
  const [selectedData2, setSelectedData2] = useState();
  const [selectedData3, setSelectedData3] = useState();
  const [selectedData4, setSelectedData4] = useState();
  const [searchValue1, setSearchValue1] = useState();
  const [searchValue2, setSearchValue2] = useState();
  const [searchValue3, setSearchValue3] = useState();
  const [searchValue4, setSearchValue4] = useState();
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [showLoadingData2, setShowLoadingData2] = useState(false);
  const [showLoadingData3, setShowLoadingData3] = useState(false);
  const [showLoadingData4, setShowLoadingData4] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [selectedsData2, setSelectedsData2] = useState([]);
  const [selectedsData3, setSelectedsData3] = useState([]);
  const [selectedsData4, setSelectedsData4] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false)
  const [banderaTags2, setBanderaTags2] = useState(false)
  const [banderaTags3, setBanderaTags3] = useState(false)
  const [banderaTags4, setBanderaTags4] = useState(false)
  const [tempSearchValue1, setTempSearchValue1] = useState('');
  const [tempSearchValue2, setTempSearchValue2] = useState('');
  const [tempSearchValue3, setTempSearchValue3] = useState('');
  const [tempSearchValue4, setTempSearchValue4] = useState('');


  
  const fetchFilter1 = async (filter = null) => {
    try {
      const inputQuery = `query: "getSubscription"${filter ? `, filters: { value_filter: "${filter}", type_filter: 14, key: "1", description_filter: "suscripcion" }` : ''}`;
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { ${inputQuery} }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getSubscription",
          setter: setSelectedData1,
          showLoading: setShowLoadingData1
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData1(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Manejar el error adecuadamente (por ejemplo, mostrar un mensaje de error)
    }
  };

  useEffect(() => {
    setShowLoadingData1(true)
    fetchFilter1(searchValue1)
  }, [searchValue1])

  const fetchFilter2 = async (filter = null) => {
    try {
      const inputQuery = `query: "getMarket"${filter ? `, filters: { value_filter: "${filter}", type_filter: 15, key: "1", description_filter: "mercado" }` : ''}`;
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { ${inputQuery} }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getMarket",
          setter: setSelectedData2,
          showLoading: setShowLoadingData2
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData2(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData2(true)
    fetchFilter2(searchValue2)
  }, [searchValue2])

  const fetchFilter3 = async (filter = null) => {
    const normalizedFilter = filter ? filter.toUpperCase() : null;
    try {
      const inputQuery = `query: "getAgeOfThelineCat"${filter ? `, is_like: true, like_position: 0, name_filter: "${normalizedFilter}"` : ''}`;
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { ${inputQuery} }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getAgeOfThelineCat",
          setter: setSelectedData3,
          showLoading: setShowLoadingData3
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData3(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData3(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setShowLoadingData3(true)
    fetchFilter3(searchValue3)
  }, [searchValue3])

  const fetchFilter4 = async (filter = null) => {
    const normalizedFilter = filter ? filter.toUpperCase() : null;
    try {
      const inputQuery = `query: "getPlanCat"${filter ? `, is_like: true, like_position: 0, name_filter: "${normalizedFilter}"` : ''}`;
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { ${inputQuery} }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getPlanCat",
          setter: setSelectedData4,
          showLoading: setShowLoadingData4
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData4(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData4(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData4(true)
    fetchFilter4(searchValue4)
  }, [searchValue4])


  const getValues = async ({idStatement, query, setter, showLoading}) => {
    const startTime = Date.now();
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${query}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });
      response = result.data.getData;
      
      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Esperar 5 segundos antes de hacer la siguiente petición
      }
    }
    setter(response.length > 0 && response[0].value_filter !== "Sin Datos" ? response : [])
    showLoading(false)
  };

  const filters = [
    {
      title: 'Tipo Suscripción',
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: tipoSuscripcion,
      setFilterComponent: setTipoSuscripcion,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1,
      setShowLoadingData: setShowLoadingData1,
      onSearch: (value) => setSearchValue1(value),
      visible: true,
      searchComponent: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Row>
            <Col span={20}>
              <Search
                placeholder="Buscar"
                allowClear
                loading={showLoadingData1}
                value={tempSearchValue1} 
                onChange={(e) => setTempSearchValue1(e.target.value)} 
                onSearch={(value) => {
                  setShowLoadingData1(true);
                  setSearchValue1(value); 
                }}
              />
            </Col>
          </Row>
        </div>
      ),
    },
    {
      title: 'Mercado',
      selectedData: selectedData2,
      setSelectedData: setSelectedData2,
      selectedsData: selectedsData2,
      setSelectedsData: setSelectedsData2,
      filterComponent: mercado,
      setFilterComponent: setMercado,
      banderaTags: banderaTags2,
      setBanderaTags: setBanderaTags2,
      showLoadingData: showLoadingData2,
      setShowLoadingData: setShowLoadingData2,
      onSearch: (value) => setSearchValue2(value),
      visible: true,
      searchComponent: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Row>
            <Col span={20}>
              <Search
                placeholder="Buscar"
                allowClear
                loading={showLoadingData2}
                value={tempSearchValue2} 
                onChange={(e) => setTempSearchValue2(e.target.value)} 
                onSearch={(value) => {
                  setShowLoadingData2(true);
                  setSearchValue2(value); 
                }}
              />
            </Col>
          </Row>
        </div>
      ),
    },
    {
      title: 'Antigüedad de la línea',
      selectedData: selectedData3,
      setSelectedData: setSelectedData3,
      selectedsData: selectedsData3,
      setSelectedsData: setSelectedsData3,
      filterComponent: lineAge,
      setFilterComponent: setLineAge,
      banderaTags: banderaTags3,
      setBanderaTags: setBanderaTags3,
      showLoadingData: showLoadingData3,
      setShowLoadingData: setShowLoadingData3,
      onSearch: (value) => setSearchValue3(value),
      visible: true,
      searchComponent: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Row>
            <Col span={20}>
              <Search
                placeholder="Buscar"
                allowClear
                loading={showLoadingData3}
                value={tempSearchValue3} 
                onChange={(e) => setTempSearchValue3(e.target.value)} 
                onSearch={(value) => {
                  setShowLoadingData3(true);
                  setSearchValue3(value); 
                }}
              />
            </Col>
          </Row>
        </div>
      ),
    },
    {
      title: 'Plan del usuario',
      selectedData: selectedData4,
      setSelectedData: setSelectedData4,
      selectedsData: selectedsData4,
      setSelectedsData: setSelectedsData4,
      filterComponent: userPlan,
      setFilterComponent: setUserPlan,
      banderaTags: banderaTags4,
      setBanderaTags: setBanderaTags4,
      showLoadingData: showLoadingData4,
      setShowLoadingData: setShowLoadingData4,
      onSearch: (value) => setSearchValue4(value),
      visible: true,
      searchComponent: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <Row>
            <Col span={20}>
              <Search
                placeholder="Buscar"
                allowClear
                loading={showLoadingData4}
                value={tempSearchValue4} 
                onChange={(e) => setTempSearchValue4(e.target.value)} 
                onSearch={(value) => {
                  setShowLoadingData4(true);
                  setSearchValue4(value); 
                }}
              />
            </Col>
          </Row>
        </div>
      ),
    }
  ];

  const {
    currentPage,
    visibleItems: visibleFilters,
    handleNext,
    handlePrev,
    startIndex,
    endIndex,
  } = usePagination(filters.filter(f => f.visible));

  return (
    <Row className="DemograficosColumns" gutter={16} style={{ marginTop: '-15px' }}>
      <Col span={12}>
        <Row gutter={[16, 24]}>
          {visibleFilters.map((filter) => (
            <Col span={12} key={filter.title}>
              <h3 style={{ marginBottom: 0 }}>{filter.title}</h3>
              {filter.searchComponent}
              <FiltersTable
                selectedData={filter.selectedData}
                setSelectedData={filter.setSelectedData}
                selectedsData={filter.selectedsData}
                setSelectedsData={filter.setSelectedsData}
                filterComponent={filter.filterComponent}
                setFilterComponent={filter.setFilterComponent}
                banderaTags={filter.banderaTags}
                setBanderaTags={filter.setBanderaTags}
                showLoadingData={filter.showLoadingData}
                setShowLoadingData={filter.setShowLoadingData}
              />
            </Col>
          ))}
        </Row>
        {filters.filter(f => f.visible).length > visibleFilters.length && (
          <Row style={{ marginTop: '10px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.filter(f => f.visible).length}
              />
            </div>
          </Row>
        )}
      </Col>
      
      <Col span={12} style={{ justifyContent: 'flex-end' }}>
      <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end' }}>
        <Card
          style={{
            width: 500,
            height: 300,
            marginTop: 20,
            overflow: 'auto',
            borderRadius: 15,
          }}
        >
          {selectedsData1.map(({ key, value_filter }) => (
            <Tag
              key={key}
              className="TagsSelectFilters"
              closable
              onClose={() => {
                remove(selectedsData1, { value_filter: value_filter })
                setSelectedsData1([...selectedsData1])
                setBanderaTags1(true)
              }}
              
            >
              {value_filter}
            </Tag>
          ))}
          {selectedsData2.map(({ key, value_filter }) => (
            <Tag
              key={key}
              className="TagsSelectFilters"
              closable
              onClose={() => {
                remove(selectedsData2, { value_filter: value_filter })
                setSelectedsData2([...selectedsData2])
                setBanderaTags2(true)
              }}
            >
              {value_filter}
            </Tag>
          ))}
          {selectedsData3.map(({ key, value_filter }) => (
            <Tag
              key={key}
              className="TagsSelectFilters"
              closable
              onClose={() => {
                remove(selectedsData3, { value_filter: value_filter })
                setSelectedsData3([...selectedsData3])
                setBanderaTags3(true)
              }}
            >
              {value_filter}
            </Tag>
          ))}
          {
          selectedsData4 && selectedsData4.map(({ key, value_filter, type }) => (
            <Tag
              key={key}
              className="TagsSelectFilters"
              closable
              onClose={() => {
                remove(selectedsData4, { value_filter: value_filter })
                setSelectedsData4([...selectedsData4])
                setBanderaTags4(true)
              }}
            >
              {value_filter}
            </Tag>
              )
            )
          }
        </Card>
      </Row>
    </Col>
    </Row>
  )
}
export default UserProfile;